import { hash } from 'spark-md5';

export const genIdbHash = (str: string): string => hash(str);
